import * as address from 'src/api/address'
import router from 'src/router'
import {
  GET_ALL_ADDRESS,
  GET_ADDRESS
} from 'src/store/mutation-types'

const getAllAddress = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  address.getAllAddress(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ADDRESS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_ADDRESS, [])
    }
  })
}

const getAddress = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  address.getAddress(configs).then(response => {
    switch (response.code) {
      case 200:
        dispatch('toggleLoadding', false, {root: true})
        commit(GET_ADDRESS, response.data)
        break
      case 404:
        dispatch('toggleLoadding', false, {root: true})
        dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Địa chỉ không tồn tại trên hệ thống',
          type: 'warning'
        }, {root: true})
        router.push({name: 'address'})
        break
      default:
        dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setAddress = ({commit}, address) => {
  commit(GET_ADDRESS, address)
}

export default{
  getAllAddress,
  getAddress,
  setAddress
}



// WEBPACK FOOTER //
// ./src/components/address/store/actions.js